/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { State } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { filter$, map$ } from '@gh/rx/operators';
import { negate } from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { HpeCommandService } from '../hpe-command.service';
import {
  HpeDetailsState,
  queryHpeEditable,
  queryHpeSelectedCostCenter,
  queryHpeSelectedCostCenterId,
  queryHpeSelectedItemId,
} from '../hpe-details.state';

@Component({
  standalone: false,
  selector: 'gh-hpe-details-cc-parent',
  templateUrl: 'hpe-details-cc-parent.component.html',
  styleUrls: ['hpe-details-cc-parent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HpeDetailsCcParentComponent implements OnInit, OnDestroy {
  memo$: Observable<string>;
  hasSelectedItem$: Observable<boolean>;

  editable: boolean;
  costCenterId: ID;
  private costCenterIdSubscription: Subscription;

  constructor(private state: State<HpeDetailsState>,
              private commands: HpeCommandService) {
  }

  ngOnInit(): void {
    const costCenterId$ = this.state.select(queryHpeSelectedCostCenterId).pipe(filter$(Boolean));
    this.memo$ = this.state.select(queryHpeSelectedCostCenter).pipe(map$((cc) => cc && cc.memo || ''));
    this.hasSelectedItem$ = this.state.select(queryHpeSelectedItemId).pipe(map$(negate(Boolean)));

    this.editable = this.state.project(queryHpeEditable);

    this.costCenterIdSubscription = costCenterId$.subscribe((id: any) => this.costCenterId = id);
  }

  ngOnDestroy(): void {
    this.costCenterIdSubscription.unsubscribe();
  }

  onMemoChange(memo: string): void {
    const { costCenterId } = this;

    if (costCenterId) {
      this.commands.costCenterSetField(costCenterId, 'memo', memo);
    }
  }
}
